import React, { useState, useEffect } from "react";
import "./AtmWithdrawal.css";
import {
  fetchTransactionDetails,
  fetchAccountHolderDetails,
  handleWithdrawal,
} from "./services/api";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { handleTruncateApi, handleInsertApi } from "./services/api";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa"; // Import the required icons
import { useNavigate } from "react-router-dom";

const AtmWithdrawalnew = () => {
  const [isTransactionSuccessful, setTransactionSuccessful] = useState(false);
  const [amount, setAmount] = useState("1,000");
  const [transactionDetails, setTransactionDetails] = useState({
    accountNumber: "",
    availableBalance: "",
    nonTagAmount: "",
    totalTagAmount: "",
  });
  const [transactionMessage, setTransactionMessage] = useState("");
  const [loading, setLoading] = useState(false); // Loader state for Truncate API
  const [loading1, setLoading1] = useState(false); // Loader state for Insert API
  const [status, setStatus] = useState(null);
  const [status1, setStatus1] = useState(null);

  const formatNumberWithCommas = (value) => {
    if (value == null || isNaN(value)) {
      return "";
    }
    value = value.toString().replace(/[^0-9]/g, "");
    if (value.length > 3) {
      let lastThree = value.slice(-3);
      let otherNumbers = value.slice(0, value.length - 3);
      otherNumbers = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
      return otherNumbers + "," + lastThree;
    }
    return value;
  };

  useEffect(() => {
    document.title = "TAGER AI-ATM";
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const details = await fetchTransactionDetails();
        setTransactionDetails(details);

        const accountHolder = await fetchAccountHolderDetails();
        if (accountHolder) {
          setTransactionDetails((prevDetails) => ({
            ...prevDetails,
            ...accountHolder,
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleAmountChange = (e) => {
    let numericValue = e.target.value.replace(/[^0-9]/g, "");
    const formattedValue = formatNumberWithCommas(numericValue);
    setAmount(formattedValue);
  };

  const handleTransfer = () => {
    if (amount) {
      const numericAmount = parseFloat(amount.toString().replace(/,/g, ""));
      const payload = {
        accountNumber: transactionDetails.accountNumber,
        amount: numericAmount,
      };
      handleWithdrawal(
        transactionDetails,
        numericAmount,
        setTransactionSuccessful,
        setTransactionMessage,
        setTransactionDetails
      );
    } else {
      alert("Please enter an amount!");
    }
  };
  // Function to call the truncate API
  const handleTruncate = async () => {
    setLoading(true); // Show loader
    try {
      const status = await handleTruncateApi();
      setStatus(status);
      setTimeout(() => setStatus(null), 1000);
    } catch (error) {
      console.error("Error during truncate operation:", error);
    } finally {
      setLoading(false); // Hide loader
    }
  };

  // Function to call the insert-data API
  const handleInsert = async () => {
    setLoading1(true); // Show loader
    try {
      const status1 = await handleInsertApi();
      setStatus1(status1);
      setTimeout(() => setStatus1(null), 1000);
    } catch (error) {
      console.error("Error during insert operation:", error);
    } finally {
      setLoading1(false); // Hide loader
    }
  };

  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleLogout = () => {
    // Clear login status from localStorage
    localStorage.removeItem("isLoggedIn");

    // Notify other tabs about logout
    localStorage.setItem("logout-event", Date.now());

    // Redirect to LoginPage (forces reload in all tabs)
    window.location.href = "/";
  };

  return (
    <>
      <h1 className="main-title">
        Withdraw / Spend Restrictions
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </h1>
      <div className="container-fluid atm-page">
        <div className="row align-items-center justify-content-center vh-100">
          {/* Left Container */}
          <div className="col-md-5 text-center p-4">
            {/* Buttons Positioned Above atm_container */}
            <div className="top_btn_wrpatm mx-auto d-flex justify-content-center row">
              <div
                className="col-6 d-flex justify-content-start"
                style={{ marginTop: "-205px" }} // Adjust this for the Bank 2 button
              >
                <button className="btn btn-success btn_fontatm">Bank 2</button>
              </div>
              <div
                className="col-6 d-flex justify-content-end"
                style={{ marginTop: "-205px" }} // Adjust this for the Tager Code B2 button
              >
                <button className="btn btn-success btn_font">
                  Tager Code B2
                </button>
              </div>
            </div>

            {/* ATM Container */}
            <div
              className="atm_container"
              style={{ backgroundColor: "transparent" }}>
              <div className="transaction-container">
                {/* Static Labels */}
                <div className="transaction-details">
                  <p>
                    <strong style={{ fontFamily: "sans-serif" }}>
                      Account Number:
                    </strong>

                    <span className="value1">
                      {transactionDetails.accountNumber}
                    </span>
                  </p>
                  <p
                    className="center-text"
                    style={{ marginLeft: "26px", fontFamily: "sans-serif" }}>
                    <strong>Available Balance:</strong>
                  </p>
                  <div className="balance-value">
                    <span className="value">
                      ₹{" "}
                      {formatNumberWithCommas(
                        transactionDetails.availableBalance.toString()
                      )}
                    </span>
                  </div>
                </div>

                {/* Tagged and Non-Tagged Amount */}
                <div style={{ marginLeft: "20px", marginTop: "55px" }}>
                  <p className="small-text single-line">
                    <strong>Tagged Amount:</strong>
                    <span className="valueatm">
                      ₹{" "}
                      {formatNumberWithCommas(
                        transactionDetails.totalTagAmount.toString()
                      )}
                    </span>
                  </p>
                  <p className="small-text single-line">
                    <strong>Non-Tagged Amount:</strong>
                    <span className="valueatm">
                      ₹{" "}
                      {formatNumberWithCommas(
                        transactionDetails.nonTagAmount.toString()
                      )}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Arrow */}
          <div className="col-1 d-flex align-items-center">
            <div className="horizondal_arrow_container d-flex justify-content-center">
              <div className="arrow-and-dataatm">
                <br /> &#8592;
              </div>
            </div>
          </div>

          {/* Right Container */}

          <div className="col-md-6 text-center p-5">
            <div className="position-relative">
              {/* Background Image */}
              <img
                src={require("./asserts/bgatm 2.png")}
                alt="ATM Background"
                className="img-fluid mb-3"
              />

              {/* Icon Containers */}
              {transactionMessage && (
                <div>
                  {/* Vertical Icons */}
                  <div
                    className="icon-container position-absolute"
                    style={{
                      top: "-57%",
                      right: "-33%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "160px",
                    }}>
                    {Array(3)
                      .fill(null)
                      .map((_, index) => (
                        <React.Fragment key={`vertical-icon-${index}`}>
                          {transactionMessage === "ATM withdrawal approved!" ? (
                            <CheckCircleIcon
                              style={{
                                color: "green",
                                fontSize: "30px",
                                cursor: "pointer",
                                marginLeft: "8px",
                                marginLeft: index === 0 ? "-18px" : "10px",
                                marginTop: "-10px",
                              }}
                            />
                          ) : (
                            <CancelIcon
                              style={{
                                color: "red",
                                fontSize: "30px",
                                cursor: "pointer",
                                marginLeft: "8px",
                                marginLeft: index === 0 ? "-18px" : "10px",
                                marginTop: "-10px",
                              }}
                            />
                          )}
                        </React.Fragment>
                      ))}
                  </div>

                  {/* Horizontal Icons */}
                  <div
                    className="icon-container-horizontal position-absolute"
                    style={{
                      bottom: "20%",
                      left: "36%",
                      transform: "translateX(-50%)",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "140px",
                    }}>
                    {Array(2)
                      .fill(null)
                      .map((_, index) => (
                        <React.Fragment key={`horizontal-icon-${index}`}>
                          {transactionMessage === "ATM withdrawal approved!" ? (
                            <CheckCircleIcon
                              style={{
                                color: "green",
                                fontSize: "30px",
                                cursor: "pointer",
                                marginLeft: "30px",
                              }}
                            />
                          ) : (
                            <CancelIcon
                              style={{
                                color: "red",
                                fontSize: "30px",
                                cursor: "pointer",
                                marginLeft: "30px",
                              }}
                            />
                          )}
                        </React.Fragment>
                      ))}
                  </div>
                </div>
              )}

              {/* Transaction Status */}
              {transactionMessage ? (
                <div
                  className="transaction-status position-absolute d-flex justify-content-center align-items-center"
                  style={{
                    top: "37%",
                    left: "35%",
                    transform: "translate(-50%, -50%)",
                  }}>
                  {transactionMessage === "ATM withdrawal approved!" ? (
                    <div
                      className="success-message text-center p-3"
                      style={{
                        width: "150px",
                        marginLeft: "-12px",
                        height: "120px",
                        fontWeight: "bold",
                        fontFamily: "sans-serif",
                      }}>
                      <CheckCircleIcon
                        style={{ color: "green", fontSize: "35px" }}
                      />
                      <p>{transactionMessage}</p>
                    </div>
                  ) : (
                    <div
                      className="failure-message text-center p-3"
                      style={{
                        width: "150px",
                        marginLeft: "-12px",
                        height: "120px",
                        fontWeight: "bold",
                        fontFamily: "sans-serif",
                      }}>
                      <CancelIcon style={{ color: "red", fontSize: "35px" }} />
                      <p>{transactionMessage}</p>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className="amount-containeratm-overlay position-absolute d-flex justify-content-center align-items-center"
                  style={{
                    top: "38.5%",
                    left: "34%",
                    transform: "translate(-50%, -50%)",
                    padding: "28px",
                  }}>
                  <div
                    className="amount-containeratm d-flex flex-column justify-content-center align-items-center"
                    style={{
                      width: "100%",
                      height: "10%",
                    }}>
                    <input
                      type="text"
                      className="form-control me-2"
                      value={amount}
                      onChange={handleAmountChange}
                      style={{
                        width: "90px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    />
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        handleTransfer();
                        setTransactionSuccessful(true); // Trigger the status view
                      }}
                      style={{
                        width: "70px",
                        fontSize: "12px",
                        textAlign: "center",
                        lineHeight: "1.5",
                        padding: "7px 0",
                        marginTop: "7px",
                        backgroundColor: "#3385c9",
                        fontFamily: "sans-serif",
                      }}>
                      Withdraw
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        {/* Separate boxes below each half */}

        <div className="button-container">
          <button
            className={`circle-button ${
              status === "success" ? "green" : "red"
            }`}
            onClick={handleTruncate}
            disabled={loading} // Disable button while loading
          >
            {loading ? (
              <span className="loader">...</span> // Show loader
            ) : status === "success" ? (
              <FaCheckCircle />
            ) : null}{" "}
            {/* No text */}
          </button>

          <button
            className={`circle-button2 ${
              status1 === "success" ? "green" : "red"
            }`}
            onClick={handleInsert}
            disabled={loading1} // Disable button while loading
          >
            {loading1 ? (
              <span className="loader">...</span> // Show loader
            ) : status1 === "success" ? (
              <FaCheckCircle />
            ) : null}{" "}
            {/* No text */}
          </button>
        </div>
      </div>
    </>
  );
};

export default AtmWithdrawalnew;
